import styled from 'styled-components';
import { Typography } from '@mui/material';
import { DEVICE } from '@app/styles';

const SLIDE_HEIGHT = '340px';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const InternetSlideBackground = styled.div<any>`
  width: 100%;
  background: #ebf0f4;
  height: auto;
  min-height: ${SLIDE_HEIGHT};
  position: relative;
  display: flex;
  justify-content: center;
  @media ${DEVICE.laptop} {
    min-height: 250px;
  }
  @media ${DEVICE.mobileOnly} {
    min-height: 200px;
  }
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const InternetSlideInfoWrapper = styled.div<any>`
  max-width: 50%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  min-height: ${SLIDE_HEIGHT};
  padding: 24px 0;
  position: relative;
  z-index: 1;

  @media ${DEVICE.laptop} {
    max-width: 75%;
    min-height: 250px;
  }
  @media ${DEVICE.mobileOnly} {
    max-width: 100%;
    background: #ffffffd1;
    padding: 10px 20px;
    min-height: 200px;
  }
`;

interface IInternetSlideImgWrapperProps {
  background?: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const InternetSlideImgWrapper = styled.div<any>`
  background-image: url(${(props: IInternetSlideImgWrapperProps) =>
    props.background});
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  background-size: cover;
  width: 100%;
  min-height: ${SLIDE_HEIGHT};
  background-position: right;
  padding: 20px 0;
  position: relative;
  
  @media ${DEVICE.laptop} {
    min-height: 250px;
  }
  @media ${DEVICE.mobileOnly} {
    min-height: 200px;
  }
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const InternetSliderFontHeader = styled(Typography as any)`
  font-size: 2rem !important;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif !important;
  font-weight: 500 !important;
  line-height: 1.534 !important;
  letter-spacing: 0em !important;
  @media ${DEVICE.laptop} {
    font-size: 1.5rem !important;
  }
  @media ${DEVICE.mobileOnly} {
    font-size: 1.1rem !important;
  }
`;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const InternetSliderFontDescription = styled(Typography as any)`
  font-family: Ubuntu, Roboto, Helvetica !important;
  line-height: 1.1 !important;
  font-size: 1rem !important;
  margin-top: 30px !important;
  @media ${DEVICE.laptop} {
    display: none;
  }
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const InternetSliderBoxWrapper = styled.div<any>`
  margin-top: 35px;
  display: flex;
  align-items: center;
  
  @media ${DEVICE.mobileOnly} {
    margin-top: 20px;
  }
`;
